import Vue from 'vue'
const arrayUtil = {
  mapLevelList2Tree (list) {
    const initLevel = 1
    let result = []
    let currentLevel = initLevel

    const getDeepestChildren = level => {
      let children = result

      for (let l = level; l > initLevel; l--) {
        children = children[children.length - 1].children
      }

      return children
    }

    for (let i = 0; i < list.length; i++) {
      if (list[i].level <= currentLevel + 1) {
        const deepestChild = getDeepestChildren(list[i].level)

        deepestChild.push({ ...list[i], children: [] })
        currentLevel = list[i].level
      }
    }

    return result
  }
}

Vue.prototype.$array = arrayUtil
